import { render, staticRenderFns } from "./AutomaticSignOut.vue?vue&type=template&id=fa311680&"
import script from "./AutomaticSignOut.vue?vue&type=script&lang=js&"
export * from "./AutomaticSignOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports